import { render, staticRenderFns } from "./PracticeWait.vue?vue&type=template&id=1eec5058"
import script from "./PracticeWait.vue?vue&type=script&lang=ts"
export * from "./PracticeWait.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports